{
    "smartTasks": {
        "generate": {
            "focusApp": {
                "title": "Konzentrieren Sie sich auf die App",
                "description": "Konzentrieren Sie sich auf die App, in der der generierte Text erscheinen soll. Klicken Sie auf „Generieren“, um Text nahtlos an dieser Stelle zu generieren."
            }
        },
        "rewrite": {
            "focusApp": {
                "title": "Konzentrieren Sie sich auf die App",
                "description": "Konzentrieren Sie sich auf die App, in der der umgeschriebene Text erscheinen soll. Klicken Sie auf „Generieren“, um Text nahtlos an dieser Stelle zu generieren."
            }
        }
    },
    "customControls": {
        "tourLabel": "Immer verfügbare globale und Gerätesteuerungen",
        "rowDescription": "Globale und Gerätesteuerungen sind immer verfügbar, wenn Ihr Mikrofon eingeschaltet ist, unabhängig von der verwendeten App. Sie können diese Steuerungen verwenden, um mit Ihrem Gerät zu interagieren, ohne neue App-Steuerungen erstellen zu müssen. Sie enthalten hilfreiche Befehle wie das Wechseln von Steuerungen oder Apps, das Generieren von Text, das Pausieren Ihres Mikrofons und mehr."
    },
    "profile": {
        "switch": {
            "title": "App-Steuerung umschalten",
            "description": "Die Steuerelemente Ihrer App können je nach verwendeter App automatisch umgeschaltet werden, oder Sie können sie hier jederzeit manuell ändern."
        }
    },
    "dictation": {
        "tourLabel": "Diktat",
        "learn": "Erfahren Sie, wie Sie mit dem Diktiermodus Ihre Sprache freihändig in Text umwandeln.",
        "welcome": {
            "title": "Diktat",
            "description": "Mit der Diktierfunktion können Sie natürlich sprechen und Ihre Worte direkt während des Sprechens abtippen lassen. Es ist, als hätten Sie einen persönlichen Assistenten, der alles tippt, was Sie sagen."
        },
        "microphone": {
            "title": "Schalten Sie Ihr Mikrofon ein",
            "description": "Schalten Sie zunächst Ihr Mikrofon ein. Klicken Sie dazu auf den Mikrofonschalter im Cephable-Panel."
        },
        "activate": {
            "title": "Diktiermodus starten",
            "description": "Die Sprachsteuerung startet im Befehlsmodus. Um das Diktieren zu starten, sagen Sie „Diktat starten“ oder klicken Sie auf die Schaltfläche „Diktieren“. Schalten wir jetzt den Diktiermodus ein."
        },
        "focus": {
            "title": "Konzentrieren Sie sich auf ein Textfeld oder Dokument",
            "description": "Das Diktieren funktioniert am besten, wenn Sie sich auf ein Textfeld oder Dokument konzentrieren. Klicken Sie auf das Textfeld oder Dokument, in das Sie diktieren möchten."
        },
        "speaking": {
            "title": "Fangen Sie an zu sprechen",
            "description": "Jetzt können Sie lossprechen. Alles, was Sie sagen, wird in das Textfeld oder Dokument eingegeben, auf das Sie sich konzentriert haben. Sagen Sie beispielsweise: „Hallo, dies ist ein Test des Diktiermodus.“"
        },
        "pauseResume": {
            "title": "Diktat pausieren",
            "description": "Brauchen Sie eine Pause, ohne die Diktierfunktion auszuschalten? Sagen Sie einfach „Diktat pausieren“. Sie können jederzeit mit „Diktat starten“ fortfahren. Sie können die Funktion mit Ihren globalen Always-On- und Gerätesteuerungen weiter anpassen."
        },
        "stop": {
            "title": "Diktat stoppen",
            "description": "Möchten Sie zurück zur App-Steuerung wechseln? Sagen Sie einfach „Diktat beenden“. Dadurch wird der Diktiermodus beendet und Sie kehren in den Befehlsmodus zurück. Sie können jederzeit mit „Diktat starten“ fortfahren."
        },
        "complete": {
            "description": "Das war's! Sie können jetzt diktieren, pausieren, fortsetzen und zwischen Diktier- und Befehlsmodus wechseln. Diktieren ist ein leistungsstarkes Tool für freihändiges Tippen. Verwenden Sie es zum Schreiben von E-Mails, Dokumenten oder anderen Texten, die Sie laut tippen müssen."
        }
    },
    "microphone": {
        "tourLabel": "Sprachsteuerung",
        "learn": "Erfahren Sie, wie Sie jede App mit Ihrer Stimme steuern und Ihre Worte per Diktierfunktion eintippen können.",
        "rowDescription": "Wenn das Mikrofon ausgeschaltet ist, hören wir Ihre Sprachbefehle überhaupt nicht. Wenn Sie es jedoch einschalten, können Sie globale Befehle verwenden, um Pause, Start und mehr umzuschalten. Schalten wir es ein.",
        "tryOpen": {
            "title": "Versuchen Sie, „Öffne Spotify“ oder „Öffne Word“ zu sagen."
        },
        "finishedCommands": {
            "title": "Ausgezeichnet! Sie haben die Grundlagen der Sprachsteuerung gelernt.",
            "description": "Sie können die Tour jederzeit von der Support-Seite aus erneut aufrufen. Im nächsten Schritt erfahren Sie mehr über die Diktierfunktion. Sie können die Tour von der Support-Seite aus starten."
        }
    },
    "tour": {
        "startTour": "Tour starten",
        "finishTour": "Tour beenden",
        "statusDialog": "Weitere Informationen finden Sie im Panel.",
        "step": "Schritt {{step}} von {{total}}",
        "skipTour": "Tour überspringen"
    },
    "onboarding": {
        "overview": "Überblick",
        "learn": "Informieren Sie sich über die Funktionen von Cephable und deren Verwendung.",
        "start": "Sie scheinen gerade erst anzufangen. Hier sind einige Bereiche, die Ihnen dabei helfen werden.",
        "dashboard": {
            "title": "Cephable-Arbeitsbereich",
            "description": "Der Cephable-Arbeitsbereich ist Ihre zentrale Anlaufstelle für die Verwaltung Ihres Geräts, der App-Steuerung und der Einstellungen. Hier können Sie Ihre Benutzererfahrung anpassen, aktive Befehle anzeigen und auf alle Funktionen von Cephable zugreifen."
        },
        "step1": {
            "title": "Willkommen bei Cephable",
            "description": "Cephable ist Ihre persönliche KI – entwickelt für schnelle Aktionen, Sprachbefehle, Inhaltsgenerierung und intelligente Automatisierung Ihrer Tools. Sofort einsatzbereite Steuerung. Keine Cloud-Verarbeitung. Nur Produktivität, die mit Ihnen mitgeht."
        },
        "finish": {
            "continueToApp": "Weiter zum Cephable Dashboard",
            "keepExploring": "Weiter entdecken"
        },
        "useCaseSlider": {
            "context": "Ich möchte verwenden",
            "control": "kontrollieren"
        }
    },
    "support": {
        "description": "Weitere Informationen zur Verwendung von Cephable, einschließlich weiterer Touren, Schritt-für-Schritt-Anleitungen, Tutorials und Videos, finden Sie in unserem Support-Hub.",
        "title": "Unterstützung"
    },
    "editingVideos": {
        "tourLabel": "Konzentrieren Sie sich auf die Geschichte, nicht auf die mühsamen Klicks zur Videobearbeitung",
        "learn": "Lernen Sie, wie Sie Sprachsteuerung und Diktierfunktion nutzen können, um Videos schneller zu bearbeiten und die kognitive Belastung durch das Merken der richtigen Schaltflächen während der Bearbeitung zu reduzieren.",
        "tryOpen": {
            "title": "Versuchen Sie, `CapCut öffnen` oder `iMovie öffnen` zu sagen."
        },
        "complete": {
            "description": "Sie wissen nun, wie Sie Sprachbefehle und Schnellaktionen nutzen, um in Ihren bevorzugten Videobearbeitungs-Apps die Wiedergabe zu starten, anzuhalten, Titel zu überspringen und die Lautstärke anzupassen. Entdecken Sie weitere Befehle oder erstellen Sie eigene Schnellaktionen für eine noch komfortablere Videosteuerung."
        }
    },
    "congrats": "Glückwunsch!",
    "fpsGamePlay": {
        "tourLabel": "Spielen Sie FPS-Spiele mit Sprachsteuerung",
        "learn": "Erfahren Sie, wie Sie Sprachsteuerung und Schnellaktionen zum Spielen von FPS-Spielen verwenden.",
        "tryOpen": {
            "title": "Versuchen Sie, „Öffne Valorant“ oder „Öffne Battlefield“ zu sagen."
        },
        "complete": {
            "description": "Sie wissen jetzt, wie Sie Sprachbefehle und Schnellaktionen verwenden, um Ihren Charakter in FPS-Spielen zu bewegen, anzuhalten und zu steuern. Entdecken Sie weitere Befehle oder passen Sie Ihre eigenen Schnellaktionen an, um ein noch flüssigeres und schnelleres Gameplay zu erzielen."
        }
    },
    "redo": "Onboarding wiederholen",
    "title": "Lernen Sie Cephable kennen",
    "description": "Lernen Sie Cephable kennen, Ihren persönlichen KI-Assistenten, und teilen Sie Ihr Interesse an personalisierten Anwendungsfällen.",
    "panel": {
        "description": "Dies ist das Bedienfeld, die zentrale Steuerungseinheit. Sie ist immer sichtbar und ermöglicht die Steuerung Ihrer Apps per Sprachbefehl und vieles mehr. Beginnen wir mit dem Mikrofon."
    },
    "controlExpanded": {
        "tourLabel": "Kontrolle",
        "description": "Die App-Steuerelemente sind vorkonfigurierte Steuerelemente, die Sie in einer gewünschten Anwendung verwenden können. In diesem Abschnitt werden Ihnen alle verfügbaren Steuerelemente angezeigt, die Sie per Sprachbefehl, Tippen, Eingabe und mehr nutzen können."
    },
    "submit": {
        "title": "Einreichen",
        "description": "Der Inhalt wird an der Stelle ausgegeben, an der sich der Cursor befindet."
    },
    "tryOpen": {
        "description": "„Öffnen“ ist ein globaler Befehl, der die angegebene App öffnet und ihr den Fokus gibt. Wenn die automatische Steuerungsumschaltung aktiviert ist, wird automatisch auf die Steuerelemente umgeschaltet, die am besten zur aktuell verwendeten App passen."
    },
    "modeSelector": {
        "title": "Modus auswählen",
        "description": "Falls verfügbar, können Sie den Modus auswählen, in dem ich arbeiten soll. Verwenden Sie „Steuerung“ für die App, über die Sie Befehle senden möchten, „Erstellen“ für generative Textinhalte wie „Zusammenfassen“, „Umschreiben“ und „Übersetzen“. Wählen Sie „Automatisieren“ für Desktop- oder appübergreifende Abläufe."
    },
    "contextSelector": {
        "title": "Kontext auswählen",
        "description": "Sofern verfügbar, können Sie den Kontext auswählen, in dem ich arbeiten soll. Ich kann beispielsweise Ihre Zwischenablage oder markierten Text verwenden, und Sie können mir auch Dateien oder Ordner anhängen, mit denen ich arbeiten soll."
    },
    "panelInput": {
        "title": "Was soll ich tun?",
        "description": "Sie können mir Befehle erteilen, diese eintippen oder diktieren, was ich tun soll."
    },
    "figma": {
        "tourLabel": "Sprachbefehle für Figma und Canva",
        "learn": "Lernen Sie, wie Sie die Sprachsteuerung, die Sprachmaus, die Diktierfunktion und die KI-gestützte Inhaltsgenerierung von Controls nutzen können, um Ihren Design-Workflow zu verbessern.",
        "complete": {
            "description": "Sie wissen nun, wie Sie Designs steuern und erstellen, um Ihren Workflow zu optimieren. Entdecken Sie weitere Befehle für eine noch reibungslosere Designsteuerung."
        },
        "tryOpen": {
            "title": "Versuchen Sie es mit `Figma öffnen` oder `Canva öffnen`."
        }
    },
    "voiceMouse": {
        "title": "Sprachmaus",
        "description": "Um Schaltflächen anhand ihres Namens anzuklicken, können Sie die Sprachsteuerung verwenden. Sagen Sie dazu beispielsweise „Speichern tippen“ oder „Zu den Einstellungen“."
    },
    "documentSummary": {
        "tourLabel": "Entwurf von Teamzusammenfassungen aus vertraulichen Berichten",
        "learn": "Automatisieren Sie das Durchlesen von Abteilungsberichten, identifizieren Sie die richtigen Ansprechpartner und entwerfen Sie eine E-Mail – alles direkt auf dem Gerät, damit Ihre vertraulichen Daten privat bleiben.",
        "congrats": {
            "description": "Sie wissen nun, wie Sie KI-Workflows nutzen können, um vertrauliche Dokumente zu lesen und eine zusammenfassende E-Mail an Ihr Team zu verfassen – und das alles, ohne dass Ihre Daten Ihr Gerät verlassen."
        }
    },
    "extensions": {
        "tourLabel": "Erweiterungen",
        "rowDescription": "Erweitere Cephable um zusätzliche Steuerungsmöglichkeiten für dein Gerät – wie Kamerasteuerung für Gesichts- und Kopfbewegungen oder Gamepad-Unterstützung. Aktiviere hier die gewünschten Funktionen."
    },
    "developerBuildTests": {
        "tourLabel": "Automatisieren Sie Builds und Tests mit KI-Workflows",
        "learn": "Cephable kann mehrstufige Terminalaufgaben – wie das Erstellen Ihres Projekts und das Ausführen seiner Tests – vollständig auf dem Gerät im Hintergrund ausführen, während Sie weiterarbeiten.",
        "complete": {
            "description": "Sie wissen nun, wie Sie KI-Workflows auf dem Gerät für mehrstufige Build- und Testaufgaben ausführen, auf Berechtigungsanfragen reagieren und die Ergebnisse iterativ verbessern. Versuchen Sie, eine weitere wiederkehrende Entwicklungsaufgabe zu automatisieren."
        }
    },
    "classroomStudyTools": {
        "tourLabel": "Unterrichtsnotizen und Artikel in Lernhilfen und Unterrichtsmaterialien umwandeln",
        "learn": "Cephable unterstützt Lehrer und Schüler mit Diktierfunktionen, geräteinternen Erstellungswerkzeugen und Automatisierungsfunktionen – direkt in den Apps, die Sie bereits verwenden, wobei alles privat bleibt und sich auf Ihrem Gerät befindet.",
        "complete": {
            "description": "Sie wissen nun, wie Sie direkt in Ihre Dokumente diktieren, aus Ihren Notizen neue Lernmaterialien generieren und mit Automate im Hintergrund komplette Aufgaben erstellen können – alles direkt auf Ihrem Gerät."
        }
    },
    "engineeringFlows": {
        "tourLabel": "Sprachsteuerung + KI-Automatisierungen für Entwickler",
        "learn": "Erfahren Sie, wie Sie Ihren Entwicklungs-Workflow mit sprachgesteuerten Entwicklerbefehlen, KI-gestütztem Rewrite unter Verwendung Ihres eigenen Codes als Kontext und KI-Workflows im Hintergrund beschleunigen können – alles direkt auf dem Gerät.",
        "tryOpen": {
            "title": "Versuchen Sie, „Visual Studio Code öffnen“ zu sagen."
        },
        "complete": {
            "description": "Sie wissen nun, wie Sie sprachgesteuerte Entwicklerbefehle, KI-Rewrite mit Ihrem eigenen Code als Kontext und KI-gestützte Hintergrund-Workflows nutzen können, um Ihren Entwicklungsablauf zu beschleunigen."
        }
    },
    "meetingNotesToFiles": {
        "tourLabel": "Wandeln Sie Besprechungsnotizen in verwertbare Dateien um",
        "learn": "Cephable kann Ihre Besprechungsnotizen in kleinere, überschaubare Dateien aufteilen, die Sie in Ihrem eigenen Tempo bearbeiten können – komplett auf Ihrem Gerät.",
        "complete": {
            "description": "Sie wissen nun, wie Sie KI-Workflows nutzen können, um Besprechungsnotizen in kleinere, handhabbare Dateien aufzuteilen und die Konversation jederzeit über den KI-Verlauf wieder aufzunehmen."
        }
    },
    "notesToPresentation": {
        "tourLabel": "Vertrauliche Notizen zusammenfassen und eine Präsentation erstellen – alles direkt auf dem Gerät.",
        "learn": "Cephable kann Ihre vertraulichen Berichte und Notizen zusammenfassen und anschließend mithilfe von KI-Workflows einen ganzen Ordner mit Dateien bearbeiten – und sogar eine Präsentation aus den Ergebnissen erstellen. All dies läuft direkt auf Ihrem Gerät.",
        "complete": {
            "description": "Sie wissen nun, wie Sie vertrauliche Dokumente zusammenfassen, mit KI-Workflows einen ganzen Ordner stapelweise zusammenfassen und die Ergebnisse in eine Präsentation umwandeln können – und das alles, ohne dass Ihre Daten Ihr Gerät verlassen."
        }
    },
    "organizeDownloads": {
        "tourLabel": "Dateien organisieren, aufräumen und Verlorene wiederfinden – mit KI-Workflows",
        "learn": "Automate kann mehrstufige Dateiverwaltungsaufgaben – Kopieren, Löschen und Suchen von Dateien – direkt über eine einfache Eingabeaufforderung ausführen.",
        "complete": {
            "description": "Sie wissen nun, wie Sie KI-Workflows nutzen können, um Dateien zu organisieren, sie mit Berechtigungsprüfungen sicher zu bereinigen und Dateien zu finden, deren Speicherort Sie nicht mehr wissen."
        }
    },
    "outlookEmailProductivity": {
        "tourLabel": "Beschleunigen Sie E-Mails in Outlook mit Diktierfunktion, Schnellaktionen und KI.",
        "learn": "Cephable Plus und Professional beinhalten intelligente Diktier- und Erstellungswerkzeuge zum Generieren und Bearbeiten von Inhalten – nutzen Sie diese direkt in Outlook, um E-Mails schneller zu beantworten und zu verfassen.",
        "complete": {
            "description": "Sie wissen nun, wie Sie E-Mails per Diktierfunktion beantworten, Ihre eigenen Schnellschreibaktionen nutzen und mit den Funktionen „Zusammenfassen“ und „Generieren“ E-Mail-Inhalte entwerfen und verfeinern können – alles direkt auf dem Gerät."
        }
    },
    "customizingGameControls": {
        "tourLabel": "Spiele Rollenspiele mit Sprachsteuerung",
        "learn": "Lerne, wie du Sprachsteuerung und Schnellaktionen zum Spielen von Rollenspielen einsetzt.",
        "tryOpen": {
            "title": "Versuche, „Minecraft öffnen“ zu sagen."
        },
        "complete": {
            "description": "Du weißt jetzt, wie du Sprachbefehle und Schnellaktionen nutzt, um deinen Charakter in Rollenspielen zu bewegen, anzuhalten und zu steuern. Entdecke weitere Befehle oder erstelle eigene Schnellaktionen für ein noch flüssigeres und schnelleres Spielerlebnis."
        }
    },
    "voiceToTextSocialMedia": {
        "tourLabel": "Sprach-zu-Text-Funktion für LinkedIn, Slack und Discord",
        "learn": "Verwenden Sie die intelligente Diktierfunktion, um einen Beitrag natürlich vorzulesen, und bearbeiten Sie ihn anschließend, um den Tonfall anzupassen – funktioniert auf LinkedIn, Slack, Discord und anderen Plattformen gleichermaßen.",
        "complete": {
            "description": "Sie wissen nun, wie Sie einen Beitrag diktieren und ihn mit Rewrite verfeinern können – und zwar auf LinkedIn, Slack, Discord und mehr."
        }
    },
    "aiDocumentTranslation": {
        "tourLabel": "Dokumente direkt auf dem Gerät in jede beliebige Sprache übersetzen",
        "learn": "Cephable kann ein Dokument entweder in eine Sprache nach der anderen übersetzen oder mithilfe von KI-Workflows in mehrere Sprachen gleichzeitig – alles lokal ausgeführt.",
        "complete": {
            "description": "Sie wissen nun, wie Sie ein Dokument per Diktierfunktion in eine einzige Sprache oder mithilfe von KI-Workflows in mehrere Sprachen gleichzeitig übersetzen können – alles direkt auf dem Gerät."
        }
    },
    "excelAiAutomation": {
        "tourLabel": "Analysieren Sie Tabellenkalkulationen mit privater, geräteinterner KI",
        "learn": "Cephable kann Ihre Excel-Dateien durchlesen, Fragen zu den Zahlen beantworten und noch tiefergehende Analysen durchführen – und das alles, ohne dass Ihre Daten Ihr Gerät verlassen.",
        "complete": {
            "description": "Sie wissen nun, wie Sie KI-Workflows nutzen können, um Ihre Tabellenkalkulationen zu hinterfragen, mit Nachfragen tiefergehende Informationen zu gewinnen und eine Zusammenfassung zu speichern – alles direkt auf dem Gerät."
        }
    },
    "handsFreeComputerControl": {
        "tourLabel": "Steuern Sie Ihren Computer per Sprache und Kamera",
        "learn": "Mit Cephable können Sie Ihren Computer freihändig per Sprachbefehl, Voice Mouse und kamerabasierter Kopf- und Gesichtssteuerung bedienen.",
        "tryOpenWord": {
            "title": "Versuchen Sie, „Offenes Wort“ zu sagen."
        },
        "openExtensions": {
            "title": "Öffnen Sie die Registerkarte „Erweiterungen“.",
            "description": "Um die Kamerasteuerung zu aktivieren, öffnen Sie die Registerkarte „Erweiterungen“ im Hauptfenster."
        },
        "turnOnCamera": {
            "title": "Kamerasteuerung einschalten",
            "description": "Aktivieren Sie die Kamera. Neben Ihrem Mikrofonsymbol erscheint ein Kamerasymbol, und unter Einstellungen wird ein neuer Kamerabereich angezeigt."
        },
        "cameraInPanel": {
            "title": "Kamerasteuerung in Ihrem Bedienfeld",
            "description": "Sobald Camera Controls aktiviert ist, erscheint der Kameraschalter auch in Ihrem Cephable-Panel – Cephable schaltet ihn hier für Sie ein."
        },
        "openCameraSettings": {
            "title": "Kameraeinstellungen öffnen",
            "description": "Öffnen Sie die Kameraeinstellungen, um die Steuerung von Kopf und Gesicht individuell anzupassen."
        },
        "chooseHeadMouseMode": {
            "title": "Wählen Sie einen Kopfmausmodus.",
            "description": "Wähle aus, wie die Kopfbewegung deine Maus steuert: Stetiges Gleiten, Geschwindigkeitssteigerung oder Dynamisches Gleiten."
        },
        "complete": {
            "description": "Sie wissen nun, wie Sie Ihren Computer per Sprachsteuerung, Sprachmaus und kamerabasierten Kopf- und Gesichtsbefehlen bedienen. Erkunden Sie die Kameraeinstellungen weiter, um die Steuerung an Ihre Bedürfnisse anzupassen."
        }
    },
    "handsFreeTypingDocumentCreation": {
        "tourLabel": "Dokumente freihändig erstellen und bearbeiten",
        "learn": "Nutzen Sie die Funktionen Generieren, Überarbeiten und die Sprachsteuerung zusammen, um ein Dokument – wie beispielsweise eine Rechnung – nahezu vollständig freihändig zu erstellen und zu bearbeiten.",
        "complete": {
            "description": "Sie wissen nun, wie Sie ein Dokument nahezu vollständig freihändig mit Hilfe der Funktionen „Generieren“, „Umschreiben“ und Sprachbefehlen erstellen, umschreiben und bearbeiten können."
        }
    },
    "webResearchCreateHtml": {
        "tourLabel": "Recherchiere im Web und erstelle daraus eine Website – alles direkt auf dem Gerät.",
        "learn": "Cephable kann die Websites von Mitbewerbern durchsuchen und analysieren und anschließend die gefundenen Informationen nutzen, um eine neue HTML-Seite für Sie zu generieren – komplett auf Ihrem Gerät, sodass Ihre Recherchen privat bleiben.",
        "complete": {
            "description": "Sie wissen nun, wie Sie KI-Workflows nutzen können, um die Websites von Mitbewerbern zu analysieren und aus den Ergebnissen eine neue HTML-Seite zu generieren – und das alles, ohne dass Ihre Daten Ihr Gerät verlassen."
        }
    },
    "webResearchSummarize": {
        "tourLabel": "Vorschriften recherchieren und Ergebnisse zusammenfassen – alles auf dem Gerät",
        "learn": "Cephable kann das Web durchsuchen, um Änderungen wie neue Datenschutzgesetze zu recherchieren und die Ergebnisse anschließend so zusammenzufassen, dass Ihr Team darauf reagieren kann – alles direkt auf dem Gerät, sodass Ihre Recherchen vertraulich bleiben.",
        "complete": {
            "description": "Sie wissen nun, wie Sie KI-Workflows nutzen können, um regulatorische Änderungen zu recherchieren, die Umsetzung genauer zu analysieren und die Ergebnisse als E-Mail zu formulieren, die Ihr Team dann weiter bearbeiten kann – und das alles, ohne dass Ihre Daten Ihr Gerät verlassen."
        }
    },
    "stopListening": {
        "title": "Versuchen Sie, „Hör auf zuzuhören“ zu sagen.",
        "description": "Dadurch wird Ihr Mikrofon pausiert, ohne es vollständig auszuschalten. Sagen Sie „Zuhören starten“, sobald Sie bereit sind."
    }
}
